module.exports = __webpack_public_path__ + "static/img/img-home-co-15.d4c37fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-15.png
// module id = Ifjv
// module chunks = 1